import { inject, Injectable } from '@angular/core';
import { DialogDefaultData } from 'src/app/interfaces';
import { DialogActionTypes } from 'src/app/notifications/dialogs/dialogs.enum';
import { NotificationContextAttributesService } from 'src/app/notifications/notifications-context-attributes.service';
import { RelationRequestKnd } from '../relation-request.enum';

type ModalContent = Record<RelationRequestKnd, { title: string; description: string }>;
type SuccessfulMessages = Record<RelationRequestKnd, string>;

const SUCCESSFULL_SENT_REQUEST: SuccessfulMessages = {
  DOCTOR_LINK_REQUEST: 'DOCTOR_PATIENT_LINK_REQUEST_IS_SENT',
  PATIENT_LINK_REQUEST: 'DOCTOR_PATIENT_LINK_REQUEST_IS_SENT',
  CONNECTION_REQUEST: 'RELATION_REQUEST_IS_SENT',
};

const SUCCESSFULL_REMOVE_SENT_REQUEST: SuccessfulMessages = {
  DOCTOR_LINK_REQUEST: 'DOCTOR_PATIENT_LINK_REQUEST_IS_DECLINED',
  PATIENT_LINK_REQUEST: 'DOCTOR_PATIENT_LINK_REQUEST_IS_DECLINED',
  CONNECTION_REQUEST: 'CONNECTION_REQUEST_REMOVED',
};

const SUCCESSFULL_REMOVE_ACCEPTED_REQUEST: SuccessfulMessages = {
  DOCTOR_LINK_REQUEST: 'REMOVE_LINKED_DOCTOR_PATIENT_LINK_DESCRIPTION',
  PATIENT_LINK_REQUEST: 'REMOVE_LINKED_DOCTOR_PATIENT_LINK_DESCRIPTION',
  CONNECTION_REQUEST: 'REMOVE_CONNECTION_DESCRIPTION',
};

const SUCCESSFULL_ACCEPT_RELATION_REQUEST: SuccessfulMessages = {
  DOCTOR_LINK_REQUEST: 'DOCTOR_LINK_ACCEPTED_DESCRPTION',
  PATIENT_LINK_REQUEST: 'PATIENT_LINK_ACCEPTED_DESCRPTION',
  CONNECTION_REQUEST: 'CONNECTIONS_CONFIRM_USER_INVITATION_HINT',
};

const CONFIRM_REMOVE_SENT_REQUEST: ModalContent = {
  DOCTOR_LINK_REQUEST: {
    title: 'REMOVE_DOCTOR_PATIENT_REQUEST_TITLE',
    description: 'REMOVE_DOCTOR_REQUEST_QUESTION',
  },

  PATIENT_LINK_REQUEST: {
    title: 'REMOVE_DOCTOR_PATIENT_REQUEST_TITLE',
    description: 'REMOVE_PATIENT_REQUEST_QUESTION',
  },

  CONNECTION_REQUEST: {
    title: 'REMOVE_RELATION_REQUEST_TITLE',
    description: 'REMOVE_REQUEST_CONNECTION_QUESTION',
  },
};

const CONFIRM_REMOVE_ACCEPTED_REQUEST: ModalContent = {
  DOCTOR_LINK_REQUEST: {
    title: 'REMOVE_DOCTOR_PATIENT_LINK_TITLE',
    description: 'REMOVE_LINKED_DOCTOR_LINK_QUESTION',
  },
  PATIENT_LINK_REQUEST: {
    title: 'REMOVE_DOCTOR_PATIENT_LINK_TITLE',
    description: 'REMOVE_LINKED_PATIENT_LINK_QUESTION',
  },

  CONNECTION_REQUEST: {
    title: 'REMOVE_CONNECTION_TITLE',
    description: 'REMOVE_CONNECTION_QUESTION',
  },
};

@Injectable()
export class RelationRequestDialogContextService {
  private context: RelationRequestKnd | null = null;

  private modalAttributesService = inject(NotificationContextAttributesService);

  public set modalContext(context: RelationRequestKnd) {
    this.context = context;
  }

  public get successfullSent(): string {
    return SUCCESSFULL_SENT_REQUEST[this.context];
  }

  public get successfullRemoveSentRequest(): string {
    return SUCCESSFULL_REMOVE_SENT_REQUEST[this.context];
  }

  public get successfullRemoveAcceptedRequest(): string {
    return SUCCESSFULL_REMOVE_ACCEPTED_REQUEST[this.context];
  }

  public get successfullAcceptInvitation(): string {
    return SUCCESSFULL_ACCEPT_RELATION_REQUEST[this.context];
  }

  public get successfullRestored(): string {
    return 'DIALOG_REACTIVATION_DESCRIPTION';
  }

  public get successfullReject(): string {
    return 'CONNECTION_REQUEST_DECLINED';
  }

  public get comfirmRemovalSentRequest(): DialogDefaultData {
    const { title, description } = CONFIRM_REMOVE_SENT_REQUEST[this.context];

    return {
      title: title || 'REMOVE_RELATION_REQUEST_TITLE',
      description: description || 'REMOVE_REQUEST_CONNECTION_QUESTION',
      buttons: [
        this.modalAttributesService.createDialogButton('BTN_CLOSE_HINT'),
        this.modalAttributesService.createDialogButton(
          'BTN_REMOVE_HINT',
          'btn-primary',
          DialogActionTypes.CONFIRM_ACTION,
        ),
      ],
    };
  }

  public get comfirmRemovalAcceptedRequest(): DialogDefaultData {
    const { title, description } = CONFIRM_REMOVE_ACCEPTED_REQUEST[this.context];

    return {
      title: title || 'REMOVE_CONNECTION_TITLE',
      description: description || 'REMOVE_CONNECTION_QUESTION',
      buttons: [
        this.modalAttributesService.createDialogButton('BTN_CLOSE_HINT'),
        this.modalAttributesService.createDialogButton(
          'BTN_REMOVE_HINT',
          'btn-primary',
          DialogActionTypes.CONFIRM_ACTION,
        ),
      ],
    };
  }

  public get comfirmRejectInvitationRequest(): DialogDefaultData {
    return {
      description: 'CONNECTIONS_REJECT_INVITE_DIALOG_DESCRIPTION',
      title: 'CONNECTIONS_REJECT_INVITE_DIALOG_TITLE',
      buttons: [
        this.modalAttributesService.createDialogButton('BTN_CLOSE_HINT'),
        this.modalAttributesService.createDialogButton(
          'CONNECTIONS_REJECT_INVITE_DIALOG_BTN_HINT',
          'btn-primary',
          DialogActionTypes.CONFIRM_ACTION,
        ),
      ],
    };
  }

  public get pendingConnectionDialog(): DialogDefaultData {
    return {
      title: 'CONNECTIONS_PENDING_STATUS_DIALOG_TITLE_HINT',
      description: 'CONNECTIONS_PENDING_STATUS_DIALOG_DESCRIPTION_HINT',
      buttons: [
        ...this.modalAttributesService.getDefaultCloseAttr('btn-outline-secondary'),
        this.modalAttributesService.createDialogButton(
          'CONNECTIONS_US_GO_TO_CONNECTIONS_DIALOG_BTN_HINT',
          'btn-primary',
          DialogActionTypes.GO_TO_CONNECTIONS,
        ),
      ],
    };
  }
}
